const taskTemplates = Object.freeze({
  AD_HOC: 65,
});

export default taskTemplates;
